// src/components/projectDetails/RepoActivation.js
import React, { useEffect,useState,useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { io } from "socket.io-client";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
// Helper: parse query parameters from URL
const useQuery = () => new URLSearchParams(useLocation().search);

const RepoActivation = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const token = localStorage.getItem("access_token");
  // Extract query parameters from the URL:
  const installation_id = query.get("installation_id");
  const setup_action = query.get("setup_action");

  // Capture the invoked project id from local storage (set in the previous step)
  const project_id = localStorage.getItem("invoked_project_id");

  const [statusMessage, setStatusMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const hasFetched = useRef(false);

  // Socket.io connection for real-time updates
  // useEffect(() => {
  //   console.log("🔌 SOCKET.IO CONNECTION STARTING...");
    
  //   const socketUrl = process.env.REACT_APP_SOCKET_URL || "http://localhost:5000";
  //   console.log("Connecting to:", socketUrl);
    
  //   const socket = io(socketUrl);
    
  //   socket.on("connect", () => {
  //     console.log("✅ SOCKET CONNECTED at:", new Date().toISOString());
  //     console.log("Socket ID:", socket.id);
  //   });
    
  //   socket.on("activationStatus", (data) => {
  //     console.log("📨 SOCKET EVENT RECEIVED at:", new Date().toISOString());
  //     console.log("Event data:", data);
      
  //     if (data.project_id === project_id) {
  //       console.log("✅ MATCHING PROJECT ID!");
  //       setStatusMessage(data.message);
        
  //       if (data.success) {
  //         setAlertSeverity("success");
  //       } else {
  //         setAlertSeverity("error");
  //       }
  //     }
  //   });
    
  //   socket.on("connect_error", (error) => {
  //     console.error("❌ Socket connection error:", error);
  //   });
    
  //   socket.on("disconnect", (reason) => {
  //     console.log("🔌 Socket disconnected:", reason);
  //   });
    
  //   return () => {
  //     console.log("🔌 Socket disconnecting");
  //     socket.disconnect();
  //   };
  // }, [project_id]);
  // Socket.io connection for real-time updates
useEffect(() => {
  console.log("🔌 SOCKET.IO CONNECTION STARTING...");
  
  const socketUrl = process.env.REACT_APP_SOCKET_URL;
  console.log("Connecting to:", socketUrl);
  
  const socket = io(socketUrl);
  
  socket.on("connect", () => {
    console.log("✅ SOCKET CONNECTED at:", new Date().toISOString());
    console.log("Socket ID:", socket.id);
    
    // 🎯 ADD THIS LINE: Join project room
    if (project_id) {
      socket.emit("join_project_room", { project_id: project_id });
      console.log(`🎯 Joining room for project: ${project_id}`);
    }
  });
  
  // 🎯 OPTIONAL: Add room join confirmation
  socket.on("room_joined", (data) => {
    console.log(`✅ Successfully joined room: ${data.room}`);
  });
  
  socket.on("activationStatus", (data) => {
    console.log("📨 SOCKET EVENT RECEIVED at:", new Date().toISOString());
    console.log("Event data:", data);
    
    // 🎯 ADD DEBUG: Check if rooms are working
    console.log("My project ID:", project_id);
    console.log("Message project ID:", data.project_id);
    console.log("Match?", data.project_id === project_id ? "✅ YES" : "❌ NO");
    
    if (data.project_id === project_id) {
      console.log("✅ MATCHING PROJECT ID!");
      setStatusMessage(data.message);
      
      if (data.success) {
        setAlertSeverity("success");
      } else {
        setAlertSeverity("error");
      }
    } else {
      // 🎯 ADD THIS WARNING: Shouldn't happen with rooms
      console.warn("⚠️  Got message for different project! Rooms might not be working.");
    }
  });
  
  socket.on("connect_error", (error) => {
    console.error("❌ Socket connection error:", error);
  });
  
  socket.on("disconnect", (reason) => {
    console.log("🔌 Socket disconnected:", reason);
  });
  
  return () => {
    console.log("🔌 Socket disconnecting");
    socket.disconnect();
  };
}, [project_id]);


  // On mount, call the backend API to trigger processing of activation
  useEffect(() => {
    if (!installation_id || !project_id|| hasFetched.current) return;
    // Prepare payload (user_id is omitted per your instruction)
    hasFetched.current = true;
    const payload = {
      action: "setup-project-repository",
      project_id,
      installation_id,
      setup_action,
    };
    fetch(
      // `${process.env.REACT_APP_GITHUB_APP_API_HOST_URL}/setup-project-repository`,
      // `${process.env.REACT_APP_GITHUB_APP_API_HOST_URL}/invoke-setup-project-repository-soumya`,
      `${process.env.REACT_APP_API_NEW_HOST_URL}/athrv/api/v1/github/invoke-setup-project-repository-clone`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setStatusMessage(data.message);
        setAlertSeverity(data.success ? "success" : "error");
      })
      .catch((err) => {
        console.error("Error in setup-project-repository:", err);
        setStatusMessage("Error processing activation.");
        setAlertSeverity("error");
      });
  }, [installation_id, project_id, setup_action]);

  // Handle redirect to project details page
  const handleRedirectToProject = () => {
    // Clean up localStorage
    localStorage.removeItem("invoked_project_id");
    
    // Navigate to project details page
    navigate(`/projects/${project_id}`);
  };

  return (
    <Paper sx={{ p: 2, maxWidth: 600, margin: "20px auto" }}>
      <Typography variant="h6" gutterBottom>
        Activate Your GitHub Repository
      </Typography>
      <Typography variant="body1">Project ID: {project_id}</Typography>
      <Typography variant="body1">
        Installation ID: {installation_id}
      </Typography>
      <Typography variant="body1">Setup Action: {setup_action}</Typography>
      {statusMessage && (
        <Alert severity={alertSeverity} sx={{ mt: 2 }}>
          {statusMessage}
        </Alert>
      )}
      {alertSeverity === "success" ? (
        <Box sx={{ mt: 2 }}>
          <Button variant="outlined" onClick={handleRedirectToProject}
            fullWidth
            >
            You can close this tab and return to previous page.
          </Button>
        </Box>
      ) : (
        <Box
          sx={{
            mt: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={24} />
          <Typography variant="body2" sx={{ ml: 2 }}>
            Processing... This may take a few minutes.
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default RepoActivation;